import type { ColumnsType } from "antd/es/table";
import { FormConfigType } from "../../../components/editForm";

export const DEFAULT_QUERY_DATA = {
    Code: undefined,
    Name: undefined,
    Status: undefined,
};

export const generateQueryFormConfig = (): FormConfigType => [
    {
        title: "货币代码",
        field: "Code",
        type: "input",
        placeholder: "请输入货币代码",
        style: { width: 180 },
    },
    {
        title: "货币名称",
        field: "Name",
        type: "input",
        placeholder: "请输入货币名称",
        style: { width: 180 },
    },
    {
        title: "状态",
        field: "Status",
        type: "select",
        placeholder: "请选择状态",
        options: [
            { name: "全部", id: undefined },
            { name: "可用", id: 1 },
            { name: "禁用", id: 2 },
        ],
        style: { width: 160 },
    },
];

export const statusText = (status: number) => {
    const statusMap: Record<number, string> = {
        1: "可用",
        2: "禁用",
    };
    return statusMap[status] || "未知";
}

export const generateTableColumns = (): ColumnsType => [
    {
        title: "ID",
        dataIndex: "Id",
        key: "Id",
        width: 80,
    },
    {
        title: "货币代码",
        dataIndex: "Code",
        key: "Code",
    },
    {
        title: "货币名称",
        dataIndex: "Name",
        key: "Name",
    },
    {
        title: "排序",
        dataIndex: "Sort",
        key: "Sort",
        width: 100,
    },
    {
        title: "状态",
        dataIndex: "Status",
        key: "Status",
        width: 100,
        render: statusText,
    }
];
